module.exports = __webpack_public_path__ + "img/20200108.0a051adf.png";